module.exports = __webpack_public_path__ + "img/greatF.8f8fc6b9.png";